<template>
  <li class="mr-2">
    <div class="lang-switcher">
      <a
        href="#"
        class="lang-option"
        :class="{ active: currentLang === 'de' }"
        @click.prevent="setLang('de')"
      >DE</a>
      <span class="lang-separator">|</span>
      <a
        href="#"
        class="lang-option"
        :class="{ active: currentLang === 'en' }"
        @click.prevent="setLang('en')"
      >EN</a>
    </div>
  </li>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  computed: {
    currentLang() {
      return this.$i18n.locale;
    },
  },
  methods: {
    setLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('app_locale', lang);
    },
  },
};
</script>

<style scoped>
.lang-switcher {
  display: flex;
  align-items: center;
  height: 40px;
  font-size: 13px;
  font-weight: 600;
}

.lang-option {
  color: #8094ae;
  text-decoration: none;
  padding: 2px 4px;
}

.lang-option:hover {
  color: #E8751A;
}

.lang-option.active {
  color: #E8751A;
}

.lang-separator {
  color: #8094ae;
  margin: 0 2px;
}

.dark-mode .lang-option {
  color: #8094ae;
}

.dark-mode .lang-option.active {
  color: #E8751A;
}
</style>
